module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAARVBMVEUAAAAnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrbt8POiv9wvc7jl6/HM2+lwnsxHg8Csxd+SCYgwAAAADnRSTlMAjST070zMt64zMOXIUdzNPugAAACKSURBVBjTdZHbDoQgDESngCiCBW/7/5+6Km3cNXieJifNBFpURkrRxkQjbszAymBUdo5vXCeS/7m0sQ9rz5Ken/RA0Dx/Zo0BpLHkopGQJG05502yR6xhXw677PI6SOmaT1aphpPSSpFZz8LhNHpQwxJCw4bm39p7aO/sYrK/k9P7LfRu3rHzercv5U4SqQn/oJEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_up2_active.png
// module id = aTUZ
// module chunks = 9